/** 管理后台 api.php 根地址（与登录页一致） */
export const ADMIN_API_URI =
  process.env.VUE_APP_API_URI ||
  process.env.API_URI ||
  "https://admin.aicoiot.beer/api.php";
